


















































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class SectionPagination extends Vue {
  @Prop({ type: Number, default: 1 }) currentPage!: number;
  @Prop({ type: Number, default: 1 }) totalPages!: number;
  @Prop({ type: Number, default: 8 }) maxPages!: number;

  get safeCurrent() {
    const total = Math.max(1, this.totalPages);
    return Math.min(Math.max(this.currentPage, 1), total);
  }

  get paginationItems() {
    const total = Math.max(1, this.totalPages);
    const max = Math.max(1, this.maxPages);

    if (total <= max) {
      return Array.from({ length: total }, (_, i) => ({
        type: "page",
        value: i + 1,
        key: `page-${i + 1}`,
      }));
    }

    if (max === 1) {
      return [
        {
          type: "page",
          value: this.safeCurrent,
          key: `page-${this.safeCurrent}`,
        },
      ];
    }

    if (max === 2) {
      return [
        { type: "page", value: 1, key: "page-1" },
        { type: "page", value: total, key: `page-${total}` },
      ];
    }

    const windowSize = Math.max(1, max - 2);
    const minPage = 2;
    const maxPage = total - 1;
    let start = this.safeCurrent - Math.floor(windowSize / 2);
    let end = start + windowSize - 1;

    if (start < minPage) {
      end = Math.min(maxPage, end + (minPage - start));
      start = minPage;
    }

    if (end > maxPage) {
      start = Math.max(minPage, start - (end - maxPage));
      end = maxPage;
    }

    const items: Array<{ type: string; value?: number; key: string }> = [
      { type: "page", value: 1, key: "page-1" },
    ];

    if (start > minPage) {
      items.push({ type: "ellipsis", key: "ellipsis-start" });
    }

    for (let page = start; page <= end; page += 1) {
      items.push({ type: "page", value: page, key: `page-${page}` });
    }

    if (end < maxPage) {
      items.push({ type: "ellipsis", key: "ellipsis-end" });
    }

    items.push({ type: "page", value: total, key: `page-${total}` });

    return items;
  }

  get isPrevDisabled() {
    return this.safeCurrent <= 1;
  }

  get isNextDisabled() {
    return this.safeCurrent >= this.totalPages;
  }

  emitPrev() {
    if (this.isPrevDisabled) return;
    this.$emit("prev");
  }

  emitNext() {
    if (this.isNextDisabled) return;
    this.$emit("next");
  }

  emitPage(page: number) {
    if (page === this.safeCurrent) return;
    this.$emit("page", page);
  }
}
